export const createBankApi = (api) => ({
  createBankRegistry: (fpoId, vendorId, purchaseInvoiceId = null, salesInvoiceId = null, bankData) => {
    const params = new URLSearchParams();
    if (purchaseInvoiceId) params.append("purchaseInvoiceId", purchaseInvoiceId);
    if (salesInvoiceId) params.append("salesInvoiceId", salesInvoiceId);
    const queryString = params.toString();
    return api.post(`/fpo/${fpoId}/vendor/${vendorId}/bankRegistry${queryString ? `?${queryString}` : ""}`, bankData);
  },

  createCashRegistry: (fpoId, vendorId, purchaseInvoiceId = null, salesInvoiceId = null, cashData) => {
    const params = new URLSearchParams();
    if (purchaseInvoiceId) params.append("purchaseInvoiceId", purchaseInvoiceId);
    if (salesInvoiceId) params.append("salesInvoiceId", salesInvoiceId);
    const queryString = params.toString();
    return api.post(`/fpo/${fpoId}/vendor/${vendorId}/cashRegistry${queryString ? `?${queryString}` : ""}`, cashData);
  },

  updateBankCash: (fpoId, id, data) => api.patch(`/fpo/${fpoId}/bankCash/${id}`, data),
  deleteBankCash: (fpoId, id) => api.delete(`/fpo/${fpoId}/bankCash/${id}`),

  getBankByModeTransactionType: (fpoId, transactionType) => api.get(`/fpo/${fpoId}/bank/transactionType/${transactionType}`),
  getCashByModeTransactionType: (fpoId, transactionType) => api.get(`/fpo/${fpoId}/cash/transactionType/${transactionType}`),
  getCashById: (fpoId, transactionType, id) => api.get(`/fpo/${fpoId}/transactionType/${transactionType}/cash/${id}`),
  getBankById: (fpoId, transactionType, id) => api.get(`/fpo/${fpoId}/transactionType/${transactionType}/bank/${id}`),

  downloadCashBookStatement: (fpoId, params) =>
    params === null
      ? api.get(`/fpo/${fpoId}/cash/download`, { responseType: "blob" })
      : api.get(`/fpo/${fpoId}/cash/download`, { params, responseType: "blob" }),

  downloadBankStatement: (fpoId, params) =>
    params === null
      ? api.get(`/fpo/${fpoId}/bank/download`, { responseType: "blob" })
      : api.get(`/fpo/${fpoId}/bank/download`, { params, responseType: "blob" }),

  getIfscDetails: (ifscCode) => api.get("/ifsc", { params: { ifscCode } }),

  getOverallStock: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/overallStocks`, { params: { startDate, endDate } }),
  downloadOverallStockReport: (fpoId, startDate, endDate, format = "excel") =>
    api.get(`/fpo/${fpoId}/overallStock/download`, { params: { startDate, endDate, format }, responseType: "blob" }),

  // Stock Management downloads: report is the Stock screen section (purchaseStock, purchaseReturn, purchaseOverall,
  // salesStock, salesReturn, salesOverall, overallStock); params = { format, startDate, endDate, vendor, product, search }
  downloadStockRegister: (fpoId, report, params) => {
    if (params?.format && !["excel", "pdf"].includes(params.format)) {
      throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
    }
    return api.get(`/fpo/${fpoId}/stock/${report}/download`, { params, responseType: "blob" });
  },
});
